import { Component, inject } from '@angular/core';
import { HourTypeGroupService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  HourTypeGroupCreateDto,
  HourTypeGroupDto,
  HourTypeGroupExcelDownloadDto,
  HourTypeGroupUpdateDto,
} from '../proxy/general/dtos/hour-type-group';
import { HOURTYPEGROUP_CONFIG, HOURTYPEGROUP_FIELDS } from './hour-type-group.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-hour-type-group',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, HourTypeGroupService, ConfirmationService],
  templateUrl: './hour-type-group.html',
  styleUrl: './hour-type-group.scss',
})
export class HourTypeGroup extends BaseCrudComponent<
  HourTypeGroupDto,
  HourTypeGroupCreateDto,
  HourTypeGroupUpdateDto,
  HourTypeGroupExcelDownloadDto
> {
  service = inject(HourTypeGroupService);
  config = HOURTYPEGROUP_CONFIG;
  fields = HOURTYPEGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: HourTypeGroupDto): HourTypeGroupUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'HourTypeGroup';
  }
}
